import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.scss'],
    standalone: true
})
export class InformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
